import React from 'react';
import PropTypes from 'prop-types';
import uikit from '../../../../project/uikit/styles';
import css from './Prices.module.scss';
const Prices = ({ val }) => {
    return (
        <div>
            <div style={uikit.noWrap}>{val.total_price_formatted}</div>
            {val.total_marketing_price_formatted && <div className={css.markPrice}>{val.total_marketing_price_formatted}</div>}
        </div>
    );
};
Prices.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Prices;
